// React
import React, { PureComponent } from "react";
// Redux
import { connect } from "react-redux";
import { compose } from "redux";
// Form
import { Field, reduxForm } from "redux-form";
// Validators
import { withNamespaces } from "react-i18next";
import { required } from "../../services/validators";
// Ducks
import { login, recoverPassword } from "./Login.ducks";
import { fetchClientLogo } from "../../services/clientSettings.ducks";
// Styles
import styles from "./login.css";
// Components
import Input from "../../components/Input";
import LanguageSelector from "./components/LanguageSelector";
// i18n

class Login extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isPasswordRecoveryMode: false,
      loginLogo: undefined,
      loginLogoPosition: undefined,
      designThemeStyle: undefined
    };
    this.docBody = undefined;
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    const { fetchClientLogo } = this.props;
    this.docBody = document.getElementsByTagName("body")[0];

    const data = await fetchClientLogo();

    this.setState({
      isLoading: false,
      loginLogo: data.loginLogo,
      loginLogoPosition: data.loginLogoPosition,
      designThemeStyle: data.designThemeStyle
    });

    data.designThemeStyle === "Light"
      ? this.docBody.classList.add("smart-style-2")
      : this.docBody.classList.add("smart-style-0");

    this.docBody.style.backgroundSize = "cover";
    this.docBody.style.display = "block";
    this.docBody.style.backgroundImage = `url(${data.backgroundImg})`;
  }

  componentWillUnmount() {
    this.docBody.style.backgroundSize = "";
    this.docBody.style.display = "";
    this.docBody.style.backgroundImage = "";
  }

  toggleMode = () => {
    this.setState((prevState) => ({
      isPasswordRecoveryMode: !prevState.isPasswordRecoveryMode
    }));
  };

  onSubmit = (values) => {
    if (this.state.isPasswordRecoveryMode) {
      this.props.recoverPassword(values.username);
    } else {
      this.props.login(values.username, values.password);
    }
  };

  render() {
    const {
      handleSubmit,
      i18n: { language },
      t
    } = this.props;

    const { isLoading, isPasswordRecoveryMode, loginLogo, loginLogoPosition } = this.state;

    if (isLoading) {
      return (
        <div className="loading-container">
          <i className="fa fa-circle-o-notch fa-spin fa-5x active text-primary" />
        </div>
      );
    }

    return (
      <div className="center">
        <div className="container animated fadeInDown">
          <div className="row">
            <div className="logo" style={{ textAlign: loginLogoPosition }}>
              <img src={loginLogo} alt="logo" />
            </div>
            <div className="col-xs-12 col-sm-6 col-sm-offset-3">
              <div className="well no-padding col-lg-10 col-lg-offset-1">
                <form
                  onSubmit={handleSubmit(this.onSubmit)}
                  id="login-form"
                  className="smart-form client-form"
                >
                  <header style={styles.header}>
                    {isPasswordRecoveryMode
                      ? t("modules.localization.register.anonymous.login.passwordRecovery")
                      : t("modules.localization.register.anonymous.login.signIn")}
                    <LanguageSelector language={language} />
                  </header>
                  <fieldset>
                    <Field
                      component={Input}
                      errorMessage={t(
                        "modules.localization.register.anonymous.login.invalidEmailOrId"
                      )}
                      iconClass="icon-append fa fa-user"
                      label={t("modules.localization.register.anonymous.login.emailOrId")}
                      name="username"
                      toolTip={t(
                        "modules.localization.register.anonymous.login.requestEmailOrIdTooltip"
                      )}
                      validate={required}
                    />
                    {!isPasswordRecoveryMode && (
                      <Field
                        component={Input}
                        errorMessage={t(
                          "modules.localization.register.anonymous.login.invalidPassword"
                        )}
                        iconClass="icon-append fa fa-lock"
                        label={t("modules.localization.register.anonymous.login.password")}
                        name="password"
                        toolTip={t(
                          "modules.localization.register.anonymous.login.requestPasswordTooltip"
                        )}
                        type="password"
                        validate={required}
                      />
                    )}
                  </fieldset>
                  <footer style={styles.footer}>
                    <a onClick={this.toggleMode} style={styles.forgotPassword}>
                      {isPasswordRecoveryMode
                        ? t("modules.localization.register.anonymous.login.logIn")
                        : t("modules.localization.register.anonymous.login.forgotPassword")}
                    </a>
                    <button className="btn btn-primary" type="submit">
                      {isPasswordRecoveryMode
                        ? t("modules.localization.register.anonymous.login.recoverPassword")
                        : t("modules.localization.register.anonymous.login.signIn")}
                    </button>
                  </footer>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div>
          <label className="version-label">{`${process.env.REACT_APP_VERSION}`}</label>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    logo: state.logo
});

const mapDispatchToProps = {
  fetchClientLogo,
  login,
  recoverPassword
};

export default compose(
  reduxForm({
    form: "login"
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(Login);
